import React from 'react'
import cn from 'classnames'

import { SearchIcon } from '@components/icons/SearchIcon'
import { CrossIcon } from '@components/icons/CrossIcon'
import { SearchEbookFieldProps } from './interface'

export function SearchEbookField({
  text,
  ebooks,
  placeholder,
  className,
  inputClassName,
  isShowSearchLog,
  inputRef,
  showSearchLog,
  handleTextChange,
  handleSelectBook,
  removeSearchText,
}: SearchEbookFieldProps) {
  return (
    <div ref={inputRef} className={cn('w-full', className)}>
      <div className='relative flex items-center w-full'>
        <div className='absolute left-0 ml-[20px]'>
          <SearchIcon className='text-primary' />
        </div>
        <input
          className={cn(
            'flex w-full leading-[1.8] pl-[50px] pr-[40px] border-gray-border text-[14px] font-light rounded-[8px] p-[10px] focus:border-primary focus:outline-none focus:text-primary dark:bg-dark-9 dark:text-dark-10',
            inputClassName
          )}
          autoComplete='off'
          value={text}
          placeholder={placeholder}
          onFocus={showSearchLog}
          onChange={handleTextChange}
        />
        <button
          type='button'
          className={cn('text-secondary absolute right-[15px]', {
            hidden: !text,
          })}
          onClick={removeSearchText}
        >
          <CrossIcon />
        </button>
        {isShowSearchLog && ebooks.length ? (
          <div className='absolute w-full z-10 mt-[45px] top-0 bg-white dark:bg-dark-9 border-1 border-gray rounded-[10px] max-h-[400px] overflow-y-auto shadow'>
            {ebooks.map(item => (
              <div
                key={item.ebookId}
                className='flex justify-between items-center px-[15px] py-[10px] cursor-pointer text-black-480 hover:text-primary dark:hover:text-dark-10 hover:bg-[#ebedfb] dark:hover:bg-dark text-secondary dark:text-dark-10 '
                onClick={() => handleSelectBook(item)}
              >
                <span className='text-[14px] font-light line-clamp-1 overflow-wrap-anywhere'>
                  {item.ebookTitle}
                </span>
                <div className='text-[14px] text-secondary-100 font-light min-w-[60px] pl-[10px]'>
                  ID : {item.ebookId}
                </div>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  )
}
